import { render, staticRenderFns } from "./example.vue?vue&type=template&id=2a32ba6a"
import script from "./example.vue?vue&type=script&lang=js"
export * from "./example.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports